
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter, State } from "vuex-class";
import { EventRegion } from "@/store/site-monitor/types";

const SessionStore = namespace("sessions");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {},
})
export default class Sessions extends Vue {
	@Prop(Number)
	public resourceId!: number;

	@Prop(Number)
	public eventId!: number | null;

	@SiteMonitor.State private eventRegion: EventRegion;

	@SessionStore.Action private updateSession: ({ resourceId, eventId }) => Promise<number>;
	@SessionStore.Mutation clearResourceSessionId: (resourceId: number) => void;

	public updateTimeout: NodeJS.Timer | null = null;

	public mounted() {
		this.update();
	}

	public destroyed() {
		if (this.updateTimeout != null) {
			clearTimeout(this.updateTimeout);
		}
	}

	public async update() {
		// Remove the existing update timeout
		if (this.updateTimeout != null) {
			clearTimeout(this.updateTimeout);
		}

		if (this.resourceId != null && this.resourceId != undefined && this.eventId != undefined) {
			var responseStatus = await this.updateSession({ resourceId: this.resourceId, eventId: this.eventId });

			if (responseStatus == 401) {
				const unwatch = this.$store.watch(
					(state) => this.$store.getters.isLoggedIn,
					(n) => {
						this.update();
						unwatch();
					}
				);
			} else {
				this.updateTimeout = setTimeout(() => {
					this.update();
				}, 60000);
			}
		} else {
			this.updateTimeout = setTimeout(() => {
				this.update();
			}, 1000);
		}
	}

	/**
	 * Watches for when the current region is changed, clears out the current session id and
	 * fetches a new one from the remote data service.
	 */
	@Watch("eventRegion", { deep: true })
	public async onEventRegionChanged(newRegion: any) {
		this.clearResourceSessionId(this.resourceId);
		await this.$nextTick();
		this.update();
	}
}
